module.exports = __webpack_public_path__ + "img/default.f08a2617.svg";